import RavelloService from '@/services/ravello'
import RavelloHelper from './helper'

export default {
	install(Vue, { router, store }) {
		const helper = new RavelloHelper(store, RavelloService)
		Vue.prototype.$ravello = helper

		// Verify authentication status
		router.beforeEach((to, from, next) => {
			// Routes requiring authenticated user
			if (to.matched.some(record => record.meta.requiresAuth)) {
				if (!store.getters['session/isAuth']) {
					helper.constructor.ssoRedirectToLogin()
				}
			}

			return next()
		})

		// Initialize Session on startup
		helper.initSession()

		// Handle Ravello Service Axios errors
		RavelloService.responseInterceptor.use(response => response, (error) => {
			// Do something with response error
			if (error.response.status === 401 && helper.isAuth()) {
				store.dispatch('session/logout')
				helper.constructor.ssoRedirectToLogin()
				console.log('Auth Error')
			}
			return Promise.reject(error.response)
		})
	},
}
